module.exports = __webpack_public_path__ + "img/image-modal-success.24171c6c.svg";